import { render, staticRenderFns } from "./menuManagement.vue?vue&type=template&id=5bfec02e&scoped=true"
import script from "./menuManagement.vue?vue&type=script&lang=js"
export * from "./menuManagement.vue?vue&type=script&lang=js"
import style0 from "./menuManagement.vue?vue&type=style&index=0&id=5bfec02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfec02e",
  null
  
)

export default component.exports